import type { CancelToken } from 'axios';
import { CONFIG } from '~/_shared/constants/config';
import { apiGet } from '~/_shared/utils/api/api.helpers';

export type ReportDataRequest = {
  varlistId: string;
  country: 'usa' | 'can';
  radiiInMiles: number[];
  lat: number;
  lng: number;
  returnType?: 'json' | 'pdf';
};

type ReportDataItem = {
  tag: string;
  description: string;
  value: string;
};

type ReportArea = {
  type: string;
  extent: number;
  label: string;
  data: ReportDataItem[];
};

export type AgsReportDataResponse = {
  latitude: number;
  longitude: number;
  areas: ReportArea[];
  timeInSeconds: number;
  message: string;
};

const requestUrl = `/ags/ReportsAuth/ring/?APIkey=${CONFIG.AGS_API_KEY}`;

export const getAgsReportData = ({
  varlistId,
  country,
  lat,
  lng,
  radiiInMiles,
  returnType = 'json',
}: ReportDataRequest, cancelToken?: CancelToken): Promise<{ report: AgsReportDataResponse }> => {
  return apiGet(requestUrl, {
    radii: radiiInMiles.join(','),
    varlist: varlistId,
    country,
    latitude: lat,
    longitude: lng,
    returnType,
  }, {
    cancelToken,
  });
};
